import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import Button from './Button';
import Modal from './Modal';
import Input from './Input';
import kiosks from '../resources/kiosks';
import useIsKeyboardOpen from '../hooks/useIsKeyboardOpen';

const UnlockCodeModal = ({ visible, onClose, onSuccess, productId, connectionOk }) => {
  const { t } = useTranslation();
  const [ unlockCode, setUnlockCode ] = useState('');
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState('');

  const { keyboardDiff } = useIsKeyboardOpen();

  const handleSubmit = async () => {
    if (!unlockCode.trim()) {
      setError(t('error.unlockCodeRequired'));
      return;
    }

    setLoading(true);
    setError('');

    try {
      const trimmedUnlockCode = unlockCode.trim();
      const response = await kiosks.checkUnlockCodeAvailability(productId, trimmedUnlockCode);
      if (response.available === true) {
        onSuccess(trimmedUnlockCode);
      } else {
        setError(t('error.unlockCodeInvalid'));
      }
    } catch (error) {
      setError(t('error.unlockCodeValidationFailed'));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setUnlockCode('');
    setError('');
    setLoading(false);
    onClose();
  };

  return (
    <Modal
      title={t('unlockCode.title')}
      visible={visible}
      centered={true}
      width="500px"
      closeIcon={null}
      onCancel={handleClose}
      style={{ marginBottom: keyboardDiff }}
      footer={[
        <Button
          key="cancel"
          disabled={loading}
          onClick={handleClose}
        >
          {t('cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          disabled={!connectionOk || !unlockCode.trim()}
          onClick={handleSubmit}
        >
          {t('unlock')}
        </Button>,
      ]}
    >
      <div style={{ marginBottom: '20px' }}>
        {t('unlockCode.description')}
      </div>
      <div style={{ marginBottom: '20px' }}>
        <Input
          placeholder={t('unlockCode.placeholder')}
          value={unlockCode}
          onChange={e => setUnlockCode(e.target.value)}
          onPressEnter={handleSubmit}
          maxLength={50}
        />
      </div>
      {error && (
        <Alert
          type="error"
          message={error}
          style={{ marginBottom: '10px' }}
        />
      )}
    </Modal>
  );
};

export default UnlockCodeModal;
